import gql from 'graphql-tag'

export const insertNewsCategory = ({ data }) => {
	return {
		mutation: gql`
			mutation ($news_categories: news_categories_insert_input!) {
				insert_news_categories_one(object: $news_categories) {
					id
				}
			}
		`,
		variables: {
			news_categories: data
		}
	}
}
